// ...existing code...
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowRoutesActionsMenu = ({
  row,
  onEdit,
  onDelete,
  onCreateRouteVillage,
  onViewRouteVillages,
  hasPermissionDirect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const checkPermission = hasPermissionDirect || (() => true);

  return (
    <>
      <IconButton onClick={handleOpen} size="medium">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onCreateRouteVillage && onCreateRouteVillage(row.route_id, row.routen_name);
            handleClose();
          }}
        >
          Create Villages
        </MenuItem>

        <MenuItem
          onClick={() => {
            onViewRouteVillages && onViewRouteVillages(row.route_id, row.routen_name);
            handleClose();
          }}
        >
          View Villages
        </MenuItem>

        <MenuItem
          onClick={() => {
            onEdit && onEdit(row);
            handleClose();
          }}
        >
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            onDelete && onDelete(row.route_id || row.id);
            handleClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

RowRoutesActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onCreateRouteVillage: PropTypes.func,
  onViewRouteVillages: PropTypes.func,
  hasPermissionDirect: PropTypes.func,
};

export default RowRoutesActionsMenu;
